import { createComment } from '@chancenwerk/comments/api/createComment.js';

export namespace CommentsAPI {
  export const create = createComment;
}
